module.exports = __webpack_public_path__ + "static/media/music.2fcb9153.md";